import { useState } from "react";
import { Loader2, CheckCircle2, ShieldCheck } from "lucide-react";
import PageHero from "@/components/PageHero";
import api, { formatApiError } from "@/lib/api";

const TYPES = [
  { v: "export", label: "Export my personal data" },
  { v: "correct", label: "Correct my personal data" },
  { v: "delete", label: "Delete my personal data" },
  { v: "do_not_sell", label: "Do not sell or share my information" },
];

export default function DataRequest() {
  const [form, setForm] = useState({ name: "", email: "", type: "export", detail: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/data-requests", form); setDone(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="data-request-page">
      <PageHero label="Privacy" title="Your data, your rights." subtitle="Request an export, correction, or deletion of your personal information, or opt out of data sharing." testid="data-request-hero" />
      <section className="max-w-xl mx-auto px-6 py-16">
        <div className="eyw-card p-8">
          {done ? (
            <div className="text-center py-8" data-testid="data-request-success">
              <CheckCircle2 size={48} className="text-[#144F75] mx-auto mb-4" />
              <h3 className="font-serif text-2xl text-[#1A242B]">Request received.</h3>
              <p className="text-[#4A5D6B] mt-2">We'll process your request and be in touch. Verification may be required to protect your privacy.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="data-request-form">
              <div className="flex items-center gap-2 text-[#144F75]"><ShieldCheck size={18} /><span className="text-sm font-semibold">Privacy Request</span></div>
              <input required placeholder="Name" value={form.name} onChange={set("name")} data-testid="dr-name" className="eyw-input w-full" />
              <input required type="email" placeholder="Email on your account" value={form.email} onChange={set("email")} data-testid="dr-email" className="eyw-input w-full" />
              <select value={form.type} onChange={set("type")} data-testid="dr-type" className="eyw-input w-full">
                {TYPES.map((t) => <option key={t.v} value={t.v}>{t.label}</option>)}
              </select>
              <textarea rows={4} placeholder="Any details (optional)" value={form.detail} onChange={set("detail")} data-testid="dr-detail" className="eyw-input w-full resize-none" />
              {error && <p className="text-sm text-red-600" data-testid="dr-error">{error}</p>}
              <button type="submit" disabled={loading} data-testid="dr-submit" className="eyw-btn w-full disabled:opacity-60">
                {loading && <Loader2 className="animate-spin" size={18} />} Submit Request
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
